import { render, staticRenderFns } from "./deptPop.vue?vue&type=template&id=0c236fd2"
import script from "./deptPop.vue?vue&type=script&lang=js"
export * from "./deptPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c236fd2')) {
      api.createRecord('0c236fd2', component.options)
    } else {
      api.reload('0c236fd2', component.options)
    }
    module.hot.accept("./deptPop.vue?vue&type=template&id=0c236fd2", function () {
      api.rerender('0c236fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/dept/deptPop.vue"
export default component.exports